// Conexion para obtener datos de direcciones

import { apiFetchJson } from "./fetchWrapper";


// recibe un código postal y consulta una API 
// para obtener información de dirección 
// en México (colonias, municipio, ciudad, estado).

export const getAddressInfoForZipCode = async (zipCode) => {
  let data = null;
  try {
    // curl -X GET https://sepomex.icalialabs.com/api/v1/zip_codes\?zip_code\=04370  | jq
    const res = await apiFetchJson(`https://sepomex.icalialabs.com/api/v1/zip_codes\?zip_code\=${zipCode}`)
    data = res["zip_codes"];
  } catch (error) {
    console.error('Error fetching address info for zip code:', error);
  }
  if (!data) return null;
  
  const res = {
    zipCode: zipCode,
    neighborhoods: [],
    municipalities: [],
    city: "",
    state: ""
  }
  for (const item of data) {
    if (!res.neighborhoods.includes(item.d_asenta)) {
      res.neighborhoods.push(item.d_asenta);
    }
    res.municipality = item.d_mnpio;
    res.city = item.d_ciudad;
    if (item.d_estado === "México") {
      res.state = "Estado de México";
    } else {
      res.state = item.d_estado;
    }
  }
  return res;
}
